import * as React from 'react';
import {render} from "react-dom";
import config from './../Config/Config';

import styles from './signin.scss';

function imagePath(file) {
  return `/content/themes/tpt/dist/images/${file}`;
}

function portalUrl(provider) {
  return `${config.portal.url}/authenticate?key=${config.portal.api_key}&provider=${provider}`;
}

class SignIn extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      enabled: false
    };

    this.enable = this.enable.bind(this);
  }

  enable() {
    this.setState((prevState, props) => {
      return { enabled: true };
    });
  }

  render() {
    return <React.Fragment>
      <h3 className="headline-section">Been here before?</h3>
      <div className={`mobile-options ${this.state.enabled ? 'enabled' : ''}`}>
        <button className="theme-btn mobile-trigger" onClick={this.enable}>Sign In</button>
        <div className="providers">
          <a className="signin-option signin-option-email" data-service="email"
             href={portalUrl('pbs-email')}>
              <span className="signin-option-icon">
                <img className="signin-option-phead fa-fw"
                     src={imagePath("phead-logo.svg")}
                     alt="Sign in with Email"/>
              </span>
            <span className="signin-option-separator"></span>
            <span className="signin-option-label">Sign in with email</span>
          </a>
          <a className="signin-option signin-option-facebook"
             data-service="facebook" href={portalUrl('pbs-facebook')}>
              <span className="signin-option-icon">
                <i className="fab fa-facebook-f fa-fw"></i>
              </span>
            <span className="signin-option-separator"></span>
            <span className="signin-option-label">Sign in with Facebook</span>
          </a>
          <a className="signin-option signin-option-google" data-service="google"
             href={portalUrl('pbs-google')}>
              <span className="signin-option-icon">
                <i className="fab fa-google fa-fw"></i>
              </span>
            <span className="signin-option-separator"></span>
            <span className="signin-option-label">Sign in with Google</span>
          </a>
        </div>
      </div>
    </React.Fragment>;
  }
}

render(<SignIn/>, document.getElementById('mobile-signin'));